<template>
  <CollapsibleCard
    :value="true"
    collapsibleIcon="mdi-account-outline"
    collapsibleTitle="Kunde"
    :padding="true"
  >
    <template v-slot>
      <div v-if="loading" class="text-center pb-4">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <div v-else>
        <CardContent v-model="data" />
      </div>
    </template>
  </CollapsibleCard>
</template>

<script lang="ts">
import Vue from "vue";
import CollapsibleCard from "@/components/shared/cards/CollapsibleCard.vue";
import CardContent from "@/components/shared/cards/children/CardContent.vue";

export default Vue.extend({
  name: "ComplaintUserCard",
  props: {
    value: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    data() {
      var data = [
        {
          icon: "mdi-account-outline",
          title: "Navn",
          content: this.value?.fullName
        },
        {
          icon: "mdi-phone-in-talk-outline",
          title: "Tlf.",
          content: this.value?.mobile,
          href: this.value?.mobile
            ? `tel:${this.value?.mobile}`
            : "",
        },
        {
          icon: "mdi-email-outline",
          title: "Epost",
          content: this.value?.email,
          href: this.value?.email
            ? `mailto:${this.value?.email}`
            : "",
        },
      ];

      return data;
    },
  },
  components: {
    CollapsibleCard,
    CardContent,
  },
});
</script>
